<template>
  <transition name="fade">
    <div class="popup-overlay" v-if="visible" @click.self="close">
      <div class="popup-content">
        <div class="icon-container">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#198754" fill-opacity="0.1" stroke="#198754" stroke-width="2"/>
            <path d="M8 12L11 15L16 9" stroke="#198754" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h3>{{ title }}</h3>
        <p>{{ message }}</p>
        <button class="close-btn" @click="close">Close</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SuccessPopup",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Success!"
    },
    message: {
      type: String,
      default: ""
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  backdrop-filter: blur(4px);
}

.popup-content {
  background: white;
  padding: 30px;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  animation: slideUp 0.3s ease-out;
}

.icon-container {
  margin-bottom: 8px;
}

h3 {
  margin: 0;
  font-size: 24px;
  color: #198754;
  font-weight: 700;
}

p {
  margin: 0;
  color: #666;
  font-size: 15px;
  line-height: 1.5;
}

.close-btn {
  background: #198754;
  color: white;
  border: none;
  padding: 12px 32px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;
  margin-top: 8px;
  width: 100%;
}

.close-btn:hover {
  background: #146c38;
  transform: translateY(-2px);
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
